export default "/assets/images/tech_page_03.ed7e082ad407658a.mp4";